import { useTranslation } from '@ukpostbox/frontend-framework';
import { SendsPageItemType } from '@ukpostbox/client-data';
import { useFieldArray, useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import { useCallback, useEffect } from 'react';
import { GetArrayIndexByKeyValue } from '@ukpostbox/helpers';
import SendsPostageControl from './SendsPostageControl';

type DeliveryOptionsByCountryType = {
	postageFieldArrayName: string;
	existingData?: SendsPageItemType;
	uniqueCountries?: any;
	reset?: boolean;
};

function SendsDeliveryOptionsByCountry(props: DeliveryOptionsByCountryType) {
	const { t } = useTranslation();

	const { control, getValues, unregister } = useFormContext();

	const { fields, append, remove } = useFieldArray({
		control,
		name: props.postageFieldArrayName,
		rules: { required: 'Postage Options are required' },
	});

	const BuildCountryPostage = useCallback(() => {
		const countryListFields: any = [];
		const countryList: any = [];

		fields.forEach((item: any, index: number) => {
			const existingIndex = GetArrayIndexByKeyValue(props.uniqueCountries, 'object', item.label, 'countryCode');
			const existingIndex2 = countryListFields.indexOf(item.address?.countryCode);

			countryListFields.push(item.address?.countryCode);

			if (existingIndex === -1 || existingIndex2 !== -1) {
				remove(index);
			}
		});

		props.uniqueCountries.forEach((item: any, index: number) => {
			const existingIndex = GetArrayIndexByKeyValue(fields, 'label', item.object.countryCode);

			if (existingIndex === -1 && !countryList.includes(item.object.countryCode)) {
				countryList.push(item.object.countryCode);
				append({ label: item.object.countryCode, address: item.object });
			}
		});
	}, [fields, props.uniqueCountries]);

	useEffect(() => {
		BuildCountryPostage();
	}, [props.uniqueCountries]);

	return (
		<>
			{fields.map((address: any, index) => (
				<div key={`postageEntry${address.id}`}>
					<hr />
					<SendsPostageControl
						key={address.id}
						name={`${props.postageFieldArrayName}.${index}.value`}
						control={control}
						getValues={getValues}
						unregister={unregister}
						countryCode={address.label}
						label={t('sends.create.labels.postage')}
						reset={props.reset}
						defaultValues={
							props.existingData?.addresses?.filter((item) => item.id === address.address.addressId)[0]
								?.postageOptions
						}
					/>
				</div>
			))}
		</>
	);
}

export { SendsDeliveryOptionsByCountry };
